<template>
  <base-loader :loading="loadingData">
    <user-details-component
      :action="process"
      :loading="loading"
      :roles="roles"
      :user="userData"
      @confirm="doUser">
    </user-details-component>
  </base-loader>
</template>

<script>
  import UserDetailsComponent from "../../components/users/UserDetailsComponent"
  import Users from "../../services/Users"

  export default {
    name: 'UserDetails',
    components: {
      UserDetailsComponent
    },
    data () {
      return {
        userData: {
          roles: []
        },
        roles: [],
        userId: null,
        loading: false,
        loadingData: false
      }
    },
    methods: {
      doUser () {
        if (this.process === 'update') {
          this.updateUser()
        } else {
          this.createUser()
        }
      },
      createUser () {
        this.loading = true;
        Users.create(this.userData).then((res) => {
          this.$notificationService.success(`${this.$t('users.user')} ${this.$t('notification.successCreate')}`);
          this.$router.replace({name: 'userConfig', params: {id: res.data.id}})
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loading = false
        })
      },
      updateUser () {
        this.loading = true;
        Users.update(this.userData).then(() => {
          this.$notificationService.success(`${this.$t('users.user')} ${this.$t('notification.successUpdate')}`)
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loading = false
        })
      },
      getUserDetails () {
        this.loadingData = true;
        Users.details(this.userId).then((res) => {
          this.userData = res.data
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingData = false
        })
      },
      getRoles () {
        Users.roles().then((response) => {
          this.roles = response.data
        })
      }
    },
    computed: {
      process () {
        return (this.userId) ? 'update' : 'create'
      }
    },
    mounted () {
      this.getRoles();
      this.userId = parseInt(this.$route.params.id);
      if (this.process === 'update') {
        this.getUserDetails()
      }
    }
  }
</script>

<style scoped>

</style>
